<template>
  <v-row no-gutters align="center" justify="center">
    <!-- <v-col cols="2"></v-col> -->
    <v-col cols="12">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="3" align="center" v-for="(language, i) in languages" :key="i" class="mx-3">
          <v-badge color="green" content="Selected" v-if="getCurrentLanguage === language.code" overlap>
            <v-card height="60px" width="160px" @click="changeLanguage(language.code)" class="btnDim">
              <v-row no-gutters>
                <v-col cols="4">
                  <v-img :src="language.imageUrl" width="40" height="35" contain></v-img>
                </v-col>
                <v-col cols="8" class="text-h6 font-weight-bold primary--text">
                  {{ language.name }}
                </v-col>
              </v-row>
            </v-card>
          </v-badge>
          <v-card v-else height="60px" width="160px" @click="changeLanguage(language.code)" class="btnDim">
            <v-row no-gutters>
              <v-col cols="4">
                <v-img :src="language.imageUrl" width="40" height="35" contain></v-img>
              </v-col>
              <v-col cols="8" class="text-h6 font-weight-bold primary--text">
                {{ language.name }}
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "languageBar",
  data() {
    return {
      languages: [
        { name: 'English', code: 'en', imageUrl: require('@/assets/usa.png') },
        { name: 'Español', code: 'es-US', imageUrl: require('@/assets/mexican.png') },
      ]
    }
  },
  computed: {
    ...mapGetters(["getTouchCount", "getCurrentLanguage", "getLanguages", "getenableADA", "getKioskProfile", "getApplicationId", "getApplicationSessionId"]),
  },
  methods: {
    pullLanguage(code) {
      return this.languages.filter(lang => lang.code === code)[0].name
    },
    changeLanguage(language) {
      let date = new Date();
      if (this.getTouchCount === 0) {
        this.$store.dispatch("addSessionDatatoStrapi", {
          applicationId: this.getApplicationId,
          applicationSessionId: this.getApplicationSessionId,
          actionType: "Session Started",
          sessionPayload: {},
          timeStamp: date.toISOString(),
        })
        this.$store.commit('setTouchCount', this.getTouchCount + 1)
      }
      this.$store.commit('setRequestQna', false)
      this.$store.commit("setIsThinking", false)
      this.$store.commit("setSpeechRecognitionHandler", false);
      switch (language) {
        case "en":
          this.$store.commit("setTouchCount", this.getTouchCount + 1);
          this.$i18n.locale = "en";
          this.$store.commit("setCurrentLanguage", "en");
          this.$store.dispatch("avatarSpeak", "I am now speaking in English.");
          this.$store.dispatch("identifyAvatarLangCodes", "en");
          this.$store.commit("setSpeechRecognitionLanguage", "en-US")

          // Firebase with current language as Spanish es-US
          this.$store.dispatch("updateCurrLanguage", 'en')

          break;
        case "es-US":
          this.$i18n.locale = "es";
          this.$store.commit("setCurrentLanguage", "es-US");
          this.$store.dispatch('avatarSpeak', 'Ahora estoy hablando en español.');
          this.$store.dispatch("identifyAvatarLangCodes", "es-US");
          this.$store.commit("setSpeechRecognitionLanguage", "es-US")

          ///////// For Default location change to Spanish

          //console.log('Default Location from firebase: ', this.getKioskProfile.data().defaultLocation)
          //this.$store.commit("setDefaultLocation", this.$i18n.t("maps").filter(map => map.displayPosition.toString() === this.getKioskProfile.data().defaultLocation)[0].mapName)
          // Track the touch count and action performed.
          this.$store.commit("setTouchCount", this.getTouchCount + 1);

          // Firebase with current language as Spanish es-US
          this.$store.dispatch("updateCurrLanguage", 'es-US')

          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
.btnDim {
  width: 90%;
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>